import { z } from 'zod/v4';

import { gateSchema } from './gate.schema';

export const siteSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  type: z.string().nullable(),
  gates: z.array(gateSchema).optional(),
  geometry: z
    .object({
      type: z.literal('MultiPolygon'),
      coordinates: z.array(z.array(z.array(z.array(z.number())))),
    })
    .nullable(),
});

export type Site = z.infer<typeof siteSchema>;
